import {
  LOGIN,
  LOGOUT,
  GET_AUTH_USER,
  // CHANGE_PASSWORD,
  RESET_PASSWORD,
  UPDATE_AUTH_USER,
  GET_AUTH_PERMISSION,
  // UPDATE_AVATAR,
  GET_BANK,
  ADD_BANK,
  DELETE_BANK,
  SET_DEFAULT_BANK,
  GET_OPERATOR,
} from '../types';
import { setCookie, removeCookie, getCookie } from '../../utils/cookie';
import { NotificationManager } from 'react-notifications';
import api_Oauth2 from '../../utils/api-oauth2';
import { message } from 'antd';

export const login = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/auth/username', data)
      .then((res) => {
        if (
          res?.data?.data?.user?.userOperator ||
          res?.data?.data?.user?.collaborator ||
          res?.data?.data?.user?.operator ||
          res?.data?.data?.user?.roles?.includes('super')
        ) {
          setCookie('token', res.data.access_token, 7);
          dispatch({ type: LOGIN, payload: res.data.data });
          resolve(true);
        } else {
          message.error('You do not have permission to log in.');
          resolve(true);
        }
      })
      .catch((err) => {
        message.error('Mobile or email or password is incorrect.');
        reject(err);
      });
  });
};

export const getAuthUser = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/auth/loginToken')
      .then((res) => {
        dispatch({ type: GET_AUTH_USER, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        reject(err);
      });
  });
};

export const getOperator = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/v1/operators/get-operator')
      .then((res) => {
        dispatch({ type: GET_OPERATOR, payload: res.data });
        resolve(true);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateAuthUser = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/client/account/updateProfile', data)
      .then((res) => {
        dispatch({ type: UPDATE_AUTH_USER, payload: res.data.data });
        // console.log('res', res);
        NotificationManager.success('Cập nhật thành công!');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        // NotificationManager.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        reject(err);
      });
  });
};

export const changePassword = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await api_Oauth2.post('/auth/password', data);

      resolve(true);
    } catch (err) {
      reject(err);
    }
  });
};

export const resetPassword = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/reset-password', data)
      .then((res) => {
        dispatch({ type: RESET_PASSWORD, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        // console.log(err);
        let message = 'Đã có lỗi xảy ra, vui lòng thử lại!';
        if (err.response.data.msg) message = err.response.data.msg;
        NotificationManager.error(message);
        reject(err);
      });
  });
};

export const logout = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    removeCookie('token');
    dispatch({ type: LOGOUT });
    resolve(true);
  });
};

export const getAuthPermission = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/permission/get_all_permission_of_user')
      .then((res) => {
        dispatch({ type: GET_AUTH_PERMISSION, payload: res.data });
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const updateAvatar = (id, data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    api_Oauth2
      .post(`/users/account/update/avatar/${id}`, data)
      .then((res) => {
        dispatch({ type: UPDATE_AUTH_USER, payload: res.data.user });
        resolve(res.data);
        // console.log(res.data);
      })
      .catch((error) => {
        reject(error.response);
      });
  });
};

export const getBank = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .get('/client/account/myBankAccount')
      .then((res) => {
        dispatch({ type: GET_BANK, payload: res.data.data });
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const addBank = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post('/client/account/addBankAccount', data)
      .then((res) => {
        dispatch({ type: ADD_BANK, payload: res.data.data });
        NotificationManager.success('Thêm thành công');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const deleteBank = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .delete(`/client/account/deleteBankAccount/${id}`)
      .then((res) => {
        dispatch({ type: DELETE_BANK, payload: res.data.data });
        NotificationManager.success('Cập nhật thành công');
        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};

export const setDefaultBank = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    return api_Oauth2
      .post(`/client/account/setBankAccountDefault/${id}`)
      .then((res) => {
        dispatch({ type: SET_DEFAULT_BANK, payload: res.data.data });

        resolve(true);
      })
      .catch((err) => {
        console.error(err.response);
        reject(err);
      });
  });
};
